import { render, staticRenderFns } from "./AmazonLogin.vue?vue&type=template&id=aa538586"
import script from "./AmazonLogin.vue?vue&type=script&lang=js"
export * from "./AmazonLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports